import { createSlice } from "@reduxjs/toolkit";
import { RoleModel } from "../../../models/account/roleModel";
import { resetAll } from "../../actions/actions";
import { buscarUsuario, listarRole } from "../../../services/accountService";
import { UsuarioModel } from "../../../models/account/usuarioModel";

export interface AccountState {
  //buscar usuario
  loading: boolean;
  busca: string | null;
  usuarios: UsuarioModel[];
  usuario: UsuarioModel;
  //buscar role
  loadingRoles: boolean;
  roles: RoleModel[];
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
  modalAlterarSenha: boolean;
  modalPermissao: boolean;
}

const initialState: AccountState = {
  //buscar usuario
  loading: false,
  busca: null,
  usuarios: [],
  usuario: {} as UsuarioModel,
  //buscar role
  loadingRoles: false,
  roles: [],
  //internal
  modalCadastrar: false,
  modalDeletar: false,
  modalAlterarSenha: false,
  modalPermissao: false,
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    //buscar usuario
    setBuscaUsuario: (state, action) => {
      state.busca = action.payload;
    },
    setUsuario: (state, action) => {
      state.usuario = action.payload;
    },
    //internal
    setModalCadastrarUsuario: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarUsuario: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalAlterarSenhaUsuario: (state, action) => {
      state.modalAlterarSenha = action.payload;
    },
    setModalPermissaoUsuario: (state, action) => {
      state.modalPermissao = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estado
    builder.addCase(resetAll, () => initialState);

    //buscar role
    builder.addCase(listarRole.pending, (state) => {
      state.loadingRoles = true;
    });
    builder.addCase(listarRole.fulfilled, (state, action) => {
      state.roles = action.payload;
      state.loadingRoles = false;
    });
    builder.addCase(listarRole.rejected, (state, action) => {
      state.loadingRoles = false;
    });

    //buscar usuario
    builder.addCase(buscarUsuario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarUsuario.fulfilled, (state, action) => {
      state.usuarios = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarUsuario.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar usuario
  setBuscaUsuario,
  setUsuario,
  //internal
  setModalCadastrarUsuario,
  setModalDeletarUsuario,
  setModalAlterarSenhaUsuario,
  setModalPermissaoUsuario,
} = accountSlice.actions;

export default accountSlice.reducer;
